document.addEventListener('DOMContentLoaded', function () {
  const welcomePopup = document.getElementById("welcomePopup");
  const welcomePopupClose = document.querySelector(".welcome-popup-close");
  const appearingDelay = +welcomePopup.dataset.delay;

  function openWelcomePopup() {
    welcomePopup.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeWelcomePopup() {
    welcomePopup.classList.remove("active");
    document.body.style.overflow = "";
  }

  welcomePopupClose.addEventListener("click", closeWelcomePopup);

  window.onclick = (e) => {
    if (e.target === welcomePopup) closeWelcomePopup();
  };

  window.addEventListener("load", () => {
    const hasSeenPopup = localStorage.getItem("hasSeenWelcomePopup");

    if (!hasSeenPopup) {
      setTimeout(() => {
        openWelcomePopup();
        localStorage.setItem("hasSeenWelcomePopup", "true");
      }, appearingDelay * 1000);
    }
  });

  // Send Klaviyo Request START
  async function subscribeToKlaviyo(data, form){
    try {
      const request = await fetch(
        'https://a.klaviyo.com/ajax/subscriptions/subscribe',
        {
          method: 'POST',
          body: data
        }
      )

      if (request.status === 200) {
        const results = await request.json()
        if (results.success) {
          welcomePopup.classList.add('success');
          setTimeout(closeWelcomePopup, 3000);
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  function newsletterForms(){
    let form = document.querySelector('#welcomePopup form');

    form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const data = new FormData(form);

      console.log(Object.fromEntries(data.entries()));

      subscribeToKlaviyo(data,form);
    })
  }

  newsletterForms();
  // Send Klaviyo Request END
});